/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReduxStore } from '../../Constants/App';

export interface FiltersState {
  jobName: string[];
  jobNumber: string[];
  jobAddress: string[];
  customer: string[];
}

const initialState: FiltersState = {
  jobName: [],
  jobNumber: [],
  jobAddress: [],
  customer: [],
};

export const filtersSlice = createSlice({
  name: ReduxStore.filterState,
  initialState,
  reducers: {
    setFilterState(state, action: PayloadAction<FiltersState>) {
      return { ...state, ...action.payload };
    },
    clearFilters() {
      return initialState;
    },
  },
});

export const { setFilterState, clearFilters } = filtersSlice.actions;

export default filtersSlice.reducer;
